import React, { useState } from 'react';
import useStyles from './styles';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { div, useTheme } from '@mui/material';

import image1 from '../../utils/images/home1.jfif';
import image2 from '../../utils/images/home2.jfif';
import image3 from '../../utils/images/home3.jfif';
import uwpimg from '../../utils/images/uwp-image.png';
import uwp2 from '../../utils/images/uwp-2.jpg';
import uwp3 from '../../utils/images/uwp-3.jpg';
import uwp4 from '../../utils/images/uwp-4.jpg';
import uwp5 from '../../utils/images/uwp-5.jpg';
import uwpvc from '../../utils/images/uwp-vc.jpg';

const HomeCarousel = () => {
  const classes = useStyles();
  // eslint-disable-next-line
  const [next, setnext] = useState(false);
  const theme = useTheme();

  return (
    <div >
      <Carousel showArrows={next} showStatus={next} autoPlay={!next} infiniteLoop={!next} className={classes.carousel} showThumbs={next}>
        <div>


          <img className='lg:!w-[120vh] lg:h-[70vh] img-fluid '
            src={uwpvc}
            alt="image1" 
          />

        </div>

        <div>

          <img
            className='lg:!w-[120vh] lg:h-[70vh] img-fluid '
            src={uwpimg}
            alt="stargirl"
          ></img>

        </div>
        <div>


          <img
            className='lg:!w-[120vh] lg:h-[70vh] img-fluid '
            src={uwp3}
            alt="image1"
          />

        </div>
        <div>
          <img
            className='lg:!w-[120vh] lg:h-[70vh] img-fluid '
            src={uwp4}
            alt="image1"
          />

        </div>
        <div>


          <img
            className='lg:!w-[120vh] lg:h-[70vh] img-fluid '
            src={uwp5}
            alt="image1"
          />

        </div>
        <div
          sx={{
            height: "100%",
            display: 'flex',
          }}
        >

          <img
            className='lg:!w-[120vh] lg:h-[70vh] img-fluid '
            src={uwp2}
            alt="stargirl"
          ></img>

        </div>

      </Carousel>
    </div>
  );
};

export default HomeCarousel;
